import { Banknote, Laptop, MapPin, Package } from 'lucide-react';
import Reveal from './Reveal';
import { SITE } from '@/config/site';
import { CRISTIAN_PHOTO } from '@/config/assets';

export default function CristianSection() {
  return (
    <section id="historia" data-testid="cristian-section" className="relative border-t border-white/5 bg-noir px-5 py-24 sm:px-10 sm:py-32">
      <div className="mx-auto grid max-w-6xl items-center gap-14 lg:grid-cols-[1.1fr_0.9fr]">
        <div>
          <Reveal>
            <p className="mb-6 flex items-center gap-3 text-[10px] uppercase tracking-[0.45em] text-gold">
              <span className="h-px w-8 bg-gold/60" /> Meet Cristian
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display text-4xl uppercase leading-[1.04] text-cream sm:text-5xl lg:text-6xl">No empecé sabiendo vender.</h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-4 font-display text-xl italic text-silver sm:text-2xl">Lo aprendí haciéndolo.</p>
          </Reveal>
          <Reveal delay={0.24}>
            <p className="mt-8 max-w-md text-sm leading-relaxed text-cream/70 sm:text-base">
              Cristian Cruz es un emprendedor enfocado en la reventa online.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <ul className="mt-8 max-w-md divide-y divide-white/5 border-y border-white/5" data-testid="cristian-credentials">
              <li className="flex items-center gap-4 py-4">
                <Banknote size={16} className="shrink-0 text-gold" />
                <span className="text-xs uppercase tracking-[0.2em] text-cream/85 sm:text-sm">
                  Hago <span className="text-gold">+50K</span> al mes
                </span>
              </li>
              <li className="flex items-center gap-4 py-4">
                <Laptop size={16} className="shrink-0 text-gold" />
                <span className="text-xs uppercase tracking-[0.2em] text-cream/85 sm:text-sm">Experto en reventa online</span>
              </li>
              <li className="flex items-center gap-4 py-4">
                <MapPin size={16} className="shrink-0 text-gold" />
                <span className="text-xs uppercase tracking-[0.2em] text-cream/85 sm:text-sm">Entregas físicas y envíos a todo USA</span>
              </li>
              <li className="flex items-center gap-4 py-4">
                <Package size={16} className="shrink-0 text-gold" />
                <span className="text-xs uppercase tracking-[0.2em] text-cream/85 sm:text-sm">
                  <span className="text-gold">+100</span> envíos semanales · Proveedores
                </span>
              </li>
            </ul>
          </Reveal>
          <Reveal delay={0.32}>
            <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:gap-4">
              <a
                data-testid="cristian-cta-whatsapp"
                href={SITE.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-full bg-cream px-8 py-4 text-[11px] font-medium uppercase tracking-[0.25em] text-noir transition-colors duration-300 hover:bg-gold sm:w-auto"
              >
                Quiero empezar
              </a>
              <a
                data-testid="cristian-cta-instagram"
                href={SITE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-full border border-cream/25 px-8 py-4 text-[11px] uppercase tracking-[0.25em] text-cream/90 transition-colors duration-300 hover:border-gold hover:text-gold sm:w-auto"
              >
                Sígueme en Instagram
              </a>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <div data-testid="cristian-media-placeholder" className="relative mx-auto aspect-[4/5] w-full max-w-sm overflow-hidden border border-white/10 bg-obsidian">
            <img src={CRISTIAN_PHOTO} alt="Cristian Cruz" className="h-full w-full object-cover" data-testid="cristian-photo" />
            <div className="absolute inset-0 bg-gradient-to-t from-noir/80 via-transparent to-transparent" />
            <span className="absolute left-3 top-3 h-4 w-4 border-l border-t border-gold/70" />
            <span className="absolute right-3 top-3 h-4 w-4 border-r border-t border-gold/70" />
            <span className="absolute bottom-3 left-3 h-4 w-4 border-b border-l border-gold/70" />
            <span className="absolute bottom-3 right-3 h-4 w-4 border-b border-r border-gold/70" />
            <div className="absolute bottom-8 left-0 right-0 text-center">
              <p className="font-display text-lg uppercase tracking-[0.12em] text-cream">Cristian Cruz</p>
              <p className="mt-1 text-[8px] uppercase tracking-[0.5em] text-gold">Emprendedor · Reventa</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
